import { render, staticRenderFns } from "./CompanyInformation.vue?vue&type=template&id=08bc3146"
import script from "./CompanyInformation.vue?vue&type=script&lang=js"
export * from "./CompanyInformation.vue?vue&type=script&lang=js"
import style0 from "./CompanyInformation.vue?vue&type=style&index=0&id=08bc3146&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports